import { useNavigate } from "react-router-dom";
import { useState } from "react";

function utils({
  approvalStatusOptions,
  cities,
  setFilterObj,
  tags,
  handleResetPassword,
  setStatus,
  setOpenConfirmationModal,
  setApproval,
  setOpenEditRejectModal,
  setRejectionReason,
  navigate,
  getCities,
  filterCitites,
  cititesCount,
  getTags,
  filterTags,
  tagsCount,
  isSuperAdmin,
  permissions,
  isStore,
  id,
  currentUser,
  t,
}) {
  const filterList = [
    {
      type: "filter",
      placeholder: t("vendors.cities"),
      onChange: (value) => {
        setFilterObj((s) => {
          return { ...s, city_id: value?.value, page_number: 1 };
        });
      },
      onMenuOpen: () => {
        filterCitites?.length == 0 && getCities({});
      },
      options: filterCitites && filterCitites,
      getList: getCities,
      count: cititesCount,
      applySearchFromRequest: true,
    },
    {
      type: "filter",
      placeholder: t("vendors.tags"),
      onChange: (value) => {
        setFilterObj((s) => {
          return { ...s, tag_ids: value?.value, page_number: 1 };
        });
      },
      onMenuOpen: () => {
        filterTags?.length == 0 && getTags({});
      },
      options: filterTags && filterTags,
      getList: getTags,
      count: tagsCount,
      applySearchFromRequest: true,
    },
    {
      type: "filter",
      placeholder: t("vendors.approval_status"),
      onChange: (value) => {
        setFilterObj((s) => {
          return { ...s, profile_status: value?.value, page_number: 1 };
        });
      },
      options: approvalStatusOptions,
    },
    {
      type: "filter",
      placeholder: t("vendors.profile_status"),
      onChange: (value) => {
        setFilterObj((s) => {
          return { ...s, status: value?.value, page_number: 1 };
        });
      },
      options: [
        { id: "active", name: t("vendors.status_active") },
        { id: "suspended", name: t("vendors.status_suspend") },
        { id: "deactivated", name: t("vendors.status_delete") },
      ],
    },
  ];
  const actionsList = ({ index, data }) => {
    return [
      {
        condition: () => {
          return (isSuperAdmin || permissions?.can_read) && !isStore;
        },
        click: () => {
          navigate(`?type=details&id=${data?.id}`);
        },
        text: t("vendors.action_view_profile"),
      },
      {
        condition: () => {
          return (
            data?.details?.profile_status === "approved" &&
            data?.details?.status === "active" &&
            (isSuperAdmin || permissions?.can_update)
          );
        },
        click: () => {
          navigate(`/vendors/${data?.id}?type=edit`);
        },
        text: t("vendors.action_edit"),
      },
      {
        condition: () => {
          return (
            data?.details?.profile_status === "approved" &&
            data?.details?.status === "active" &&
            (isSuperAdmin || permissions?.can_update)
          );
        },
        click: () => {
          isSuperAdmin
            ? navigate(`change-password/${data?.id}`)
            : handleResetPassword();
        },
        text: t("vendors.action_change_password"),
      },
      {
        condition: () => {
          return (
            data?.details?.profile_status === "approved" &&
            data?.details?.status === "active" &&
            (isSuperAdmin || (permissions?.can_update && !isStore))
          );
        },
        click: () => {
          setOpenConfirmationModal(true);
          setStatus({ display: "Suspend", api: "suspended" });
        },
        text: t("vendors.action_suspend"),
      },
      {
        condition: () => {
          return (
            data?.details?.profile_status === "approved" &&
            (data?.details?.status === "active" ||
              data?.details?.status === "suspended") &&
            (isSuperAdmin ||
              permissions?.can_delete ||
              (isStore && currentUser?.id == id))
          );
        },
        click: () => {
          setStatus({ display: "Delete", api: "deleted" });

          setOpenConfirmationModal(true);
        },
        text: t("vendors.action_delete"),
      },
      {
        condition: () => {
          return (
            (data?.details?.profile_status === "pending_approval" ||
              data?.details?.profile_status === "rejected") &&
            (isSuperAdmin || permissions?.can_update) &&
            !isStore
          );
        },
        click: () => {
          setStatus({ display: "Approve", api: "approved" });
          setOpenConfirmationModal(true);
        },
        text: t("vendors.action_approve"),
      },
      {
        condition: () => {
          return (
            data?.details?.profile_status === "pending_approval" &&
            (isSuperAdmin || permissions?.can_update) &&
            !isStore
          );
        },
        click: () => {
          setApproval("reject");
          setOpenEditRejectModal({ action: true, reason: "", type: "reject" });
        },
        text: t("vendors.action_reject"),
      },
      {
        condition: () => {
          return (
            data?.details?.profile_status === "approved" &&
            data?.details?.status === "suspended" &&
            (isSuperAdmin || permissions?.can_update)
          );
        },
        click: () => {
          setOpenConfirmationModal(true);
          setStatus({ display: "Active", api: "active" });
        },
        text: t("vendors.status_active"),
      },
      {
        condition: () => {
          return (
            data?.details?.profile_status === "rejected" &&
            (isSuperAdmin || permissions?.can_update)
          );
        },
        click: () => {
          setRejectionReason(data?.details?.rejection_reason);
          setOpenEditRejectModal({
            action: true,
            reason: data?.details?.rejection_reason,
            type: "edit",
          });
        },
        text: t("vendors.action_edit_reason"),
      },
    ];
  };
  return { filterList, actionsList };
}
export default utils;
